<script setup>
import { ref, watch } from 'vue'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  users: {
    type: Array,
    default: () => []
  },
  submitting: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close', 'submit'])

const selectedUserId = ref(null)
const errorMessage = ref('')

watch(
  () => props.visible,
  (newValue) => {
    if (!newValue) {
      selectedUserId.value = null
      errorMessage.value = ''
    }
  }
)

function closeDialog() {
  if (props.submitting) return
  emit('close')
}

function submitForm() {
  errorMessage.value = ''

  if (!selectedUserId.value) {
    errorMessage.value = 'Выберите пользователя'
    return
  }

  emit('submit', selectedUserId.value)
}
</script>

<template>
  <Dialog
    :visible="props.visible"
    modal
    header="Обновить разрешения пользователя"
    :style="{ width: 'min(500px, 95vw)' }"
    class="refresh-dialog"
    :closable="!props.submitting"
    @update:visible="closeDialog"
  >
    <div class="form-container">
      <div class="field">
        <label>Пользователь</label>
        <Dropdown
          v-model="selectedUserId"
          :options="props.users"
          optionLabel="email"
          optionValue="id"
          placeholder="Выберите пользователя"
          class="w-full"
          :invalid="Boolean(errorMessage)"
          @change="errorMessage = ''"
        />
        <small v-if="errorMessage" class="field-error">
          {{ errorMessage }}
        </small>
      </div>
    </div>

    <template #footer>
      <Button
        label="Отмена"
        class="cancel-btn"
        outlined
        :disabled="props.submitting"
        @click="closeDialog"
      />
      <Button
        label="Обновить"
        icon="pi pi-refresh"
        class="submit-btn"
        :loading="props.submitting"
        :disabled="props.submitting"
        @click="submitForm"
      />
    </template>
  </Dialog>
</template>

<style scoped>
.form-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 6px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field label {
  font-size: 13px;
  font-weight: 600;
  color: #444444;
}

.field-error {
  font-size: 12px;
  color: #dc2626;
}

:deep(.p-dropdown) {
  width: 100%;
  border-radius: 14px;
  border-color: #dddddd;
  box-shadow: none;
}

:deep(.p-dropdown.p-invalid) {
  border-color: #dc2626;
}

:deep(.p-dropdown:not(.p-disabled).p-focus) {
  border-color: #111111;
  box-shadow: 0 0 0 3px rgba(196, 18, 23, 0.08);
}

:deep(.cancel-btn.p-button) {
  background: #ffffff;
  border: 1px solid #d8d8d8;
  color: #111111;
  border-radius: 999px;
  box-shadow: none;
}

:deep(.cancel-btn.p-button:hover) {
  background: #f7f7f7;
  border-color: #111111;
  color: #111111;
}

:deep(.submit-btn.p-button) {
  background: #111111;
  border: 1px solid #111111;
  color: #ffffff;
  border-radius: 999px;
  box-shadow: none;
}

:deep(.submit-btn.p-button:hover) {
  background: #2a2a2a;
  border-color: #2a2a2a;
}
</style>